module.exports = __webpack_public_path__ + "kudos_67.svg?8be23611404c12730dfe1b9a1b5068c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_67.svg
// module id = 169
// module chunks = 0